import { StyleSheet, Platform } from 'react-native';

const isWeb = Platform.OS === 'web';

export const tableStyle = StyleSheet.create({
    head: {
        height: 56,
        backgroundColor: '#f1f8ff',
        flexDirection: 'row'
    },
    row: {
        flexDirection: 'row',
        minHeight: 48,
    },
    cellText: {
        margin: 10,
        fontSize: 15,  // Increased from 12/14
        fontWeight: '500',  // Added font weight
    },
    elementText: {
        fontStyle: 'italic',
        fontWeight: '500',
    },
    border: {
        borderWidth: 1,
        borderColor: '#cbd5e1'
    },
    input: {
        margin: 10,
    },
    mainHead: {
        height: 64,  // Increased height
        backgroundColor: '#84a98c',
        flexDirection: 'row'
    },
    mainBorder: {
        borderWidth: 1,
        borderColor: '#94a3b8'
    },
    mainRow: {
        backgroundColor: '#a3b18a',
        flexDirection: 'row',
        minHeight: 52,  // Increased height
    },
    mainCellHead: {
        fontSize: 17,  // Increased from 15/16
        fontWeight: '700',  // Increased font weight
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
    mainCellText: {
        fontSize: 17,  // Increased from 15/16
        fontWeight: '700',  // Increased font weight
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 14,
        paddingBottom: 14,
    },
})